import Vue from 'vue'
import Router from 'vue-router'
import allRouter from '@/router/routerConfig.js'
import {
  Toast
} from 'vant';
Vue.use(Router)
let router = new Router({
  routes: [...allRouter],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
// 全局前置钩子函数
router.beforeEach((to, from, next) => {
       next()
})

// 全局后置钩子函数
router.afterEach((to, from) => {

})

router.onError(() => {
  Toast('菜单配置有误,请联系菜单管理员')
})
export default router
